webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* global $ ga  */
__webpack_require__(0);
(function (doc, win) {
  var docEl = doc.documentElement;
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  var recalc = function recalc() {
    var clientWidth = docEl.clientWidth;
    if (!clientWidth) return;
    if (clientWidth >= 640) {
      docEl.style.fontSize = '100px';
    } else {
      docEl.style.fontSize = 100 * (clientWidth / 640) + 'px';
    }
  };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);

var query = window.location.search.slice(1).match(/albumId=(\d+)/);
var albumId = query ? query[1] : -1;

var api = {
  submitInfo: {
    test: 'http://pre.upload.api.apusapps.com/zone/album/get-detail',
    prod: 'http://comm.apusapps.com/zone/album/get-detail'
  }
};

var env = 'prod';

// 请求相册数据
$.ajax({
  type: 'POST',
  url: api.submitInfo[env],
  data: {
    currentPage: 1,
    pageSize: 3,
    albumId: albumId
  },
  success: function success(_ref) {
    var data = _ref.data;

    console.log(data);
    render(data);
  }
});

$('footer').click(function () {
  ga('send', 'event', 'link', 'click', 'toGooglePlay-global-person-space-share-171207');
  window.location.href = 'https://play.google.com/store/apps/details?id=com.xpro.camera.lite';
});

// 模板渲染
function render(data) {
  var _ref2 = data || {},
      _ref2$describe = _ref2.describe,
      describe = _ref2$describe === undefined ? '' : _ref2$describe,
      date = _ref2.date,
      _ref2$list = _ref2.list,
      list = _ref2$list === undefined ? [] : _ref2$list;

  $('header .title').html(describe);
  $('header .date').html(date ? formatTime(date) : formatTime(parseInt(Date.now() / 1000)));
  list.filter(function (item) {
    return item.status === 0;
  }).forEach(function (item) {
    $('.images').append($('<img />').attr('src', item.url));
  });
}

// 格式化时间
function formatTime(seconds) {
  return new Date(seconds * 1000).toDateString().split(' ').slice(1).join('. ');
}

/***/ })
],[1]);


// WEBPACK FOOTER //
// static/js/global.67436dd121335f8d8b86.js